import { Schema } from '@coveo/bueno';
import { searchBoxOptionDefinitions as coreSearchBoxOptionDefinitions, } from '../../core/search-box/headless-core-search-box-options.js';
export const defaultSearchBoxOptions = {
    clearFilters: true,
};
const { id, highlightOptions, clearFilters } = coreSearchBoxOptionDefinitions;
export const searchBoxOptionDefinitions = { id, highlightOptions, clearFilters };
export const searchBoxOptionsSchema = new Schema(searchBoxOptionDefinitions);
